import request, { MethodEnum, serverTriggerUrl } from '@/utils/fetch';
import Logger from '@/utils/logger';

export enum PERMISSION_APIS {
  PERMISSION_CHECK = '/forum/thread/permission/check',
}

// 发帖权限校验
export const permissionCheck = (isServerTrigger = false, cookie?:any, device: string = 'desktop') => {
  const url = `${isServerTrigger ? serverTriggerUrl : ''}${PERMISSION_APIS.PERMISSION_CHECK}`;
  const key = 'PermissionCheck';
  return fetch(url, {
    method: MethodEnum.POST,
    credentials: 'include',
    headers: {
      Cookie: cookie,
    },
    body: JSON.stringify({ device }),
  }).then((response)=>response.json()).then((data) => data).catch((e) => {
    Logger.error({
      'path': url,
      'method': MethodEnum.POST,
      'info': key,
      'message': e?.message || e,
    })
    Promise.reject(e);
  });
};
